import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { RestPriorityResponse, PrioritySearchAPIResponse } from './types.tsx';

export const getPriorityEndpointUrl = (baseUrl: string): string => `${baseUrl}/rest/api/2/priority`;

export const getPriorityList = (
	baseUrl: string,
	_projectIdOrKey = '',
): Promise<RestPriorityResponse> => fetchJson(getPriorityEndpointUrl(baseUrl));

export const PRIORITY_SEARCH_API_ENDPOINT = '/rest/api/3/priority/search';

export const getPriorityListForProject = (projectId: string): Promise<PrioritySearchAPIResponse> =>
	fetchJson(`${PRIORITY_SEARCH_API_ENDPOINT}?projectId=${projectId}`);
